import { render, staticRenderFns } from "./appUsersGemsHistory.vue?vue&type=template&id=6956f1e8&"
import script from "./appUsersGemsHistory.vue?vue&type=script&lang=js&"
export * from "./appUsersGemsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports